<template>
  <b-card class="mb-2 card-selectable" :class="{ selected: selected }" @click="handleSelection">
    <b-icon
      variant="success"
      v-if="this.selected"
      class="position-absolute top-0"
      font-scale="2"
      icon="check-circle-fill"
    ></b-icon>
    <b-img v-if="!hideImg" :src="card.image" class="vs-img" center rounded></b-img>
    <h3
      v-if="!hideTitle"
      v-b-tooltip.hover.noninteractive.bottom
      :title="card.title"
      class="text-center mb-0 text-truncate"
    >
      {{ card.title }}
    </h3>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['hideTitle', 'hideImg']),
  },

  methods: {
    handleSelection() {
      if (!this.selected) {
        this.$emit('card-selected', this.card);
      } else this.$emit('remove-card', this.card);
    },
  },
};
</script>

<style scoped>
.vs-img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>
